import React from 'react';

interface TeamJerseyProps {
  jerseyUrl?: string;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const TeamJersey: React.FC<TeamJerseyProps> = ({ jerseyUrl, size = 'md', className = '' }) => {
  const sizeClasses = {
    sm: 'w-12 h-12',
    md: 'w-20 h-20',
    lg: 'w-28 h-28',
  };

  // Use no-jersey.png as fallback when no jersey URL is provided
  const getJerseyUrl = () => {
    return jerseyUrl || '/no-jersey.png';
  };

  return (
    <div
      className={`
        ${sizeClasses[size]} 
        rounded-full 
        flex 
        items-center 
        justify-center 
        shadow-lg 
        overflow-hidden 
        bg-black/20
        ${className}
      `}
    >
      <img src={getJerseyUrl()} alt="Team Jersey" className="w-full h-full relative" />
    </div>
  );
};

export default TeamJersey;
